import { useEffect, useState } from 'react';

export default function useDebounce(value: any, initialValue: any, delay = 500) {
    const [state, setState] = useState(initialValue);
    const [isDebouncing, setIsDebouncing] = useState(false);

    useEffect(() => {
        // If value is reset, apply immediately without debounce
        if (value === initialValue) {
            setState(initialValue);
            setIsDebouncing(false);
            return;
        }

        setIsDebouncing(true);
        // Using setTimeout() here only for debouncing purposes to avoid unnecessary API calls
        const timer = setTimeout(() => {
            setState(value);
            setIsDebouncing(false);
        }, delay);

        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);

    return { debouncedValue: state, isDebouncing };
}
